type DRAFT_STATE =
  | "UPLOAD_FILES"
  | "SELECT_LANGUAGE"
  | "REQUIREMENTS"
  | "FINISH"
  | "DONE";

type _CREATE_PROJECT_STEPS = {
  [key in DRAFT_STATE]: {
    enum: DRAFT_STATE;
    label: string;
    int: number;
    title: string;
    caption: string;
    hidden?: boolean;
  };
};

export const CREATE_PROJECT_STEPS: _CREATE_PROJECT_STEPS = {
  UPLOAD_FILES: {
    enum: "UPLOAD_FILES",
    label: "Upload Files",
    int: 0,
    title: "Upload files to dub",
    caption: "Choose video or audio files to get started"
  },
  REQUIREMENTS: {
    enum: "REQUIREMENTS",
    label: "Select Requirements",
    int: 1,
    title: "Select dubbing requirements",
    caption:
      "Get your content quality assured by our in-house experts. Optimize your dubs with Lip Sync.",
    hidden: true
  },
  SELECT_LANGUAGE: {
    enum: "SELECT_LANGUAGE",
    label: "Select Requirements",
    int: 2,
    title: "Select dubbing requirements",
    caption: "Translate your content into multiple languages at the same time"
  },
  FINISH: {
    enum: "FINISH",
    label: "Confirm",
    int: 3,
    title: "Project Summary",
    caption:
      "Your content is ready to be dubbed. All dubs will be delivered in 1080p"
  },
  DONE: {
    enum: "DONE",
    int: 4,
    title: "",
    caption: "",
    label: "",
    hidden: true
  }
};

export const CREATE_PROJECT_STEP_LABELS = [
  "Setup Project",
  "Upload files",
  "Select Language", // have to remove this
  "Requirements",
  "Finish"
];

export const PROJECT_NAME_MAX_LENGTH = 65;

export enum PROJECT_FLOW_TYPES {
  NON_ICP_NEW = "NON_ICP_NEW",
  NON_ICP_EXISTING = "NON_ICP_EXISTING",
  ICP = "ICP",
  ENTERPRISE = "ENTERPRISE"
}

export const CREATE_PROJECT_COMPACT_VIEW_WIDTH = 1440;
